export default __webpack_public_path__ + "static/media/ohpen-bcg.4953d2c0.png";